// extracted by mini-css-extract-plugin
export default {"sortWrapper":"TuVuzWra9Lt7LBfQkaHU","sortLabel":"_47oOhr3VvUt4ALYEWmbd"};